export default "__VITE_ASSET__7a88237b__"